<script setup lang="ts">
import {
  Ref,
  ref,
} from 'vue';
import { MaybeNull } from '@/shared/types';
import anime, { AnimeTimelineInstance } from 'animejs';

const leftCurtain$: Ref<MaybeNull<HTMLElement>> = ref(null);
const rightCurtain$: Ref<MaybeNull<HTMLElement>> = ref(null);

const animationTimeline: Ref<MaybeNull<AnimeTimelineInstance>> = ref(null);

const closeCurtains = ({ duration = 1500 }: { duration?: number }): Promise<boolean> => {
  return new Promise((resolve, reject) => {
    // виконуємо анімацію зашторювання
    animationTimeline.value = anime.timeline({
      complete: () => {
        if (animationTimeline.value?.reversed) {
          reject(false);
        } else {
          resolve(true);
        }

        animationTimeline.value = null;
      },
    });

    animationTimeline.value.add({
      targets: leftCurtain$.value,
      translateX: ['-100%', '0%'],
      duration,
      easing: 'easeInOutCubic',
    }, 0);

    animationTimeline.value.add({
      targets: rightCurtain$.value,
      translateX: ['100%', '0%'],
      duration,
      easing: 'easeInOutCubic',
    }, 0);
  });
};

const openCurtains = ({ duration = 1500 }: { duration?: number }): Promise<boolean> => {
  return new Promise((resolve) => {
    if (animationTimeline.value) {
      animationTimeline.value.reverse();
      setTimeout(() => {
        resolve(true);
      }, animationTimeline.value.currentTime);

      return;
    }

    animationTimeline.value = anime.timeline({
      complete: () => {
        resolve(true);

        animationTimeline.value = null;
      },
    });

    animationTimeline.value.add({
      targets: leftCurtain$.value,
      translateX: ['0%', '-100%'],
      duration,
      easing: 'easeInOutCubic',
    }, 0);

    animationTimeline.value.add({
      targets: rightCurtain$.value,
      translateX: ['0%', '100%'],
      duration,
      easing: 'easeInOutCubic',
    }, 0);
  });
};

defineExpose({
  closeCurtains,
  openCurtains,
});

</script>

<template>
  <div class="curtains-container">
    <div
      ref="leftCurtain$"
      class="left-curtain"
    />
    <div
      ref="rightCurtain$"
      class="right-curtain"
    />
  </div>
</template>

<style scoped>
.curtains-container {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 200;
}

.left-curtain,
.right-curtain {
  width: 50%;
  height: 100%;
  /* background-color: #212121; */
  background: rgba(0, 0, 0, 1);
  backdrop-filter: blur(5.5px);
}

.left-curtain {
  transform: translateX(0%);
}

.right-curtain {
  transform: translateX(0%);
}
</style>
